<template>
  <div
    v-if="!hideHeader"
    :class="[
      'border-0 d-flex align-items-center bg-transparent',
      {
        'mb-3': marginBottom
      }
    ]"
  >
    <i
      v-if="!hideIcon && icon"
      :class="`fa fa-fw ${icon} mr-2`"
    ></i>
    <div
      v-if="!hideTitle"
      ref="title"
      class="h6 font-weight-normal text-truncate mb-0 widget-title"
      v-html="title"
    ></div>
    <!--
    <a
      ref="title"
      v-if="!hideTitle && explore"
      :href="explore"
      class="h6 d-inline-block font-weight-normal text-truncate mb-0 widget-title"
      v-html="title"
    ></a>
    -->
    <div
      class="d-inline-block ml-auto"
    >
      <a
        :class="[
          'btn btn-sm btn-explore py-0',
          exploreBtnClass,
          {
            'visibility-hidden': !explore
          }
        ]"
        :href="exploreLink"
      >
        <span
          class="small"
          v-html="exploreLabel"
        ></span>
      </a>
    </div>
    <b-tooltip
      v-if="description"
      :target="() => $refs['title']"
      placement="topright"
      variant="flat-peter-river"
    >
      <div v-html="description"></div>
    </b-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.widget-title {
  max-width: 80%;
}
</style>

<script>
import { get, merge } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    marginBottom: {
      type: Boolean,
      default: true
    },
    exploreBtnClass: {
      type: String,
      default: 'btn-white'
    }
  },
  data () {
    return {
      exploreLink: null
    }
  },
  computed: {
    ...mapState('dashboard', [
      'filterValues'
    ]),
    hideHeader () {
      return get(this.$parent, 'config.options.hideHeader')
    },
    title () {
      return this.$parent.title !== null && this.$parent.title !== undefined ?
        this.$parent.title
        : this.$parent.config.title
    },
    icon () {
      return this.$parent.icon !== null && this.$parent.icon !== undefined ?
        this.$parent.icon
        : this.$parent.config.icon
    },
    description () {
      return this.$parent.description !== null && this.$parent.description !== undefined ?
        this.$parent.description
        : this.$parent.config.description
    },
    exploreLabel () {
      return get(this.$parent.config, 'exploreLabel', 'Explore')
    },
    explore () {
      return this.$parent.config.explore
    }
  },
  watch: {
    filterValues: {
      deep: true,
      handler () {
        this.updateExploreLink()
      }
    }
  },
  mounted () {
    this.updateExploreLink()
  },
  methods: {
    updateExploreLink () {
      if (this.explore) {
        let url = new URL(this.explore)
        let filters = this.filterValues
        if (url.searchParams.has('filter')) {
          let overrides = JSON.parse(atob(url.searchParams.get('filter')))
          filters = merge(filters, overrides)
        }
        url.searchParams.set('filter', btoa(JSON.stringify(filters)))
        this.exploreLink = url
      }
    }
  }
}
</script>
